/**
 * @todo
 * proper google auth onboarding collecting the photoUrl of anyone you logs in via google
 * authentication save the photoUrl in their 'users' record
 *
 * sign out from 3 dot menu in top left above logo  DONE
 * make chatbout logo
 * ask for name on register
 * take 1st letter of email address or name
 * random colour for avatar circle in chat
 * count how many active chats there are and display in side bar
 * same for total users
 * tailwind speech bubble
 * enter chat nessage with return button
 *
 *
 * user is typing message: detect on/change in input field, update the chat record with typing: true
 * this will prompt useEffect onsnap to update, typing message can be displayed
 * setInterval for typing message to turn off in 5 seconds
 * user is only can follow similar coding
 *
 */

import React, { useState, useEffect } from "react";
import { auth, provider, facebookProvider, appleProvider, db } from "../firebase-config.js";
import {
  doc,
  updateDoc,
  setDoc,
  getDoc,
  deleteDoc,
  serverTimestamp,
  getDocs,
  collection,
} from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import {
  signInWithPopup,
  onAuthStateChanged,
  signOut,
  signInAnonymously,
  EmailAuthProvider,
  getAuth,
  linkWithCredential,
} from "firebase/auth";
import "../styles/Auth.scss";
import Cookies from "universal-cookie";
import {
  saveAnonCredentials,
  readAnonCredentials,
  clearAnonCredentials,
} from "../services/anonCredentialBackup";
import { resetAllState } from "../utils/resetAllState";
import { identiconDataUri } from "../services/identicon";
import { startAnonRecovery } from "../services/anonRecoveryService";
// import { createAvatar } from '@dicebear/core';
// import { lorelei } from '@dicebear/collection';

const cookies = new Cookies();

/**
 * Drains any pending Venue Access grant queued by an admin for this
 * user's email BEFORE they had signed in. Called from the sign-in flow
 * once we have both a uid and an email. Silent + idempotent:
 *   - no matching row              → single Firestore read, done
 *   - rules deny (non-admin, wrong email token) → treated as no-op
 *   - row consumed after apply → subsequent calls short-circuit
 *
 * Mirrors applyPendingVenueAccess() in the admin dashboard's
 * userRoleService.js. Inlined here so the PWA doesn't pull the whole
 * admin service module.
 */
async function applyPendingVenueAccess(uid, email) {
  const target = String(email || '').trim().toLowerCase();
  if (!uid || !target) return { applied: false };
  const ref = doc(db, 'pendingVenueAccess', target);
  let snap;
  try { snap = await getDoc(ref); }
  catch (_) { return { applied: false }; }
  if (!snap.exists()) return { applied: false };

  const data = snap.data() || {};
  const userRef = doc(db, 'users', uid);
  const updates = {};

  if (data.grantVenue) {
    updates.userType           = 'venue_manager';
    updates.subscriptionStatus = 'active';
    updates.subscriptionTier   = 'venue_manager';
    updates.audioQuality       = '320';
    updates.subscriptionStartDate = new Date();
  }
  if (data.grantWorker) {
    updates.workerDownloadVisible   = true;
    updates.workerDownloadVisibleAt = new Date();
    updates.workerDownloadVisibleBy = data.createdBy || null;
  }
  updates.lastUpdated = new Date();

  if (Object.keys(updates).length > 1) { // more than just lastUpdated
    try { await updateDoc(userRef, updates); }
    catch (e) { console.warn('[applyPendingVenueAccess] users write failed:', e?.message); }
  }
  try { await deleteDoc(ref); } catch (_) { /* rules will re-deny; fine */ }
  return { applied: true, grantVenue: !!data.grantVenue, grantWorker: !!data.grantWorker };
}

/**
 * Pending STAFF invite drain — mirrors applyPendingStaffInvite() in the
 * admin dashboard's staffService.js. A venue manager can invite an email
 * the users-collection lookup couldn't find (account with no email field,
 * or never signed in); the invite applies here the moment that email
 * authenticates. Also stamps the email onto users/{uid} so future email
 * lookups CAN find this account — the root cause the invite worked around.
 */
async function applyPendingStaffInvite(uid, email) {
  const target = String(email || '').trim().toLowerCase();
  if (!uid || !target) return { applied: false };
  const ref = doc(db, 'pendingStaffInvites', target);
  let snap;
  try { snap = await getDoc(ref); }
  catch (_) { return { applied: false }; }
  if (!snap.exists()) return { applied: false };

  const data = snap.data() || {};
  if (!data.venueUid) {
    try { await deleteDoc(ref); } catch (_) {}
    return { applied: false };
  }
  try {
    await setDoc(doc(db, 'users', uid), {
      userType: 'venue_staff',
      staffVenueUid: data.venueUid,
      staffVenueName: data.venueName || '',
      staffAssignedAt: new Date(),
      staffAssignedBy: data.createdBy || null,
      email: target,
      lastUpdated: new Date(),
    }, { merge: true });
  } catch (e) {
    console.warn('[applyPendingStaffInvite] users write failed:', e?.message);
    return { applied: false };
  }
  try { await deleteDoc(ref); } catch (_) { /* fine */ }
  return { applied: true, venueUid: data.venueUid };
}

export const Auth = ({ setIsAuth, appMode, appLaunched, client }) => {
  const [user, setUser] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [hasAccount, setHasAccount] = useState(false);
  const [registerForm, setRegisterForm] = useState(false);
  const [launched, setLaunched] = useState(appLaunched || false);
  const [anonUser, setAnonUser] = useState({});

  const clearInputs = () => {
    setEmail("");
    setPassword("");
  };

  const clearErrors = () => {
    setEmailError("");
    setPasswordError("");
  };

  const signInWithPassword = async () => {
    clearErrors();
    await signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed up
        setIsAuth(true);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ..
      });
  };

  const registerWithPassword = async () => {
    clearErrors();
    await createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed up
        //const user = userCredential.user;
        //console.log("user", user);
        //setRegisterForm(false);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ..
      });
  };

  const updateGoogleUserProfile = async (user) => {
    // console.log("google user to update", user);

    const docRef = doc(db, "users", user.uid);
    const docSnap = await getDoc(docRef);

    // we need to say which channels this user is currently logged into


    const userData = {
      displayName: user.displayName,
      photoURL: user.photoURL,
      email: user.email,
      id: user.uid,
      channel: client,
      // only if user has signed up to be a seller
      // roles: { ECOMMERCE: "ECOMMERCE" },
      status: "online",
      updatedAt: serverTimestamp(),
    };

    if (docSnap.exists()) {
      // console.log("Document data:", docSnap.data());
      try {
        await updateDoc(docRef, { ...userData });
      } catch (err) {
        console.error("error:", err);
      }
    } else {
      // docSnap.data() will be undefined in this case
      // console.log("update new signin google user");
      try {
        await setDoc(docRef, userData);
        // copy old users data to new user
        // console.log("anonymous user", anonUser);
        // console.log("new google user", userData);
        migrateUserData(anonUser, userData);
      } catch (err) {
        console.error("error:", err);
      }

      setTimeout(() => {
        // console.log("updateGoogleUserProfile reload the page");
        window.location.reload();
      }, 3000);


    }

    // Silent drain of pending Venue Access grants queued by an admin
    // for this email. Fires AFTER the users/{uid} write so a fresh doc
    // exists (else the drain's updateDoc against a missing doc would
    // fail). Non-fatal — helper swallows rules-denied + not-found.
    try {
      await applyPendingVenueAccess(user.uid, user.email);
    } catch (e) {
      console.warn('[updateGoogleUserProfile] applyPendingVenueAccess failed:', e?.message);
    }
    try {
      await applyPendingStaffInvite(user.uid, user.email);
    } catch (e) {
      console.warn('[updateGoogleUserProfile] applyPendingStaffInvite failed:', e?.message);
    }
  };

  const saveMigratedChatData = async (chatId, chatData, userData) => {
    // console.log("saveMigratedChatData id", chatId);
    // console.log("saveMigratedChatData chatData", chatData);
    // console.log("saveMigratedChatData userData", userData);

    // const docChatRef = doc(db, "users", userData.id, "chats", chatId);
    // also update the other users in this chat groups 'chats'. get the users ids and we're updating with the same chatData
    // loop through chatData.users and avoid the one with userData.id

    chatData.users.push({
      displayName: userData.displayName,
      email: userData.email,
      id: userData.id,
    });

    chatData.updatedAt = serverTimestamp();
    // console.log("chatData", chatData);

    let itemsProcessed = 0;
    chatData.users.forEach((user, index, array) => {
      // console.log("user.id", user.id);
      const docChatRef = doc(db, "users", user.id, "chats", chatId);
      setDoc(docChatRef, chatData)
        .then(() => {
          // console.log("New Google User Chat Document successfully written!");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
      itemsProcessed++;
      if (itemsProcessed === array.length) {
        window.location.reload();
      }
    });
  };

  const migrateUserData = async (anonUser, userData) => {
    // console.log("migrating user data", anonUser, userData);
    // const docRef = collection(db, "users", anonUser.uid, "chats");

    const querySnapshot = await getDocs(
      collection(db, `users/${anonUser.uid}/chats`)
    );
    querySnapshot.forEach((doc) => {
      // add the new user id to the chat and then copy this chat to the new google id user documents
      // console.log("doc", doc.id, " => ", doc.data());
      // console.log("anon user chat doc.id", doc.id);
      // console.log("new google user userData", userData);

      const chatData = {
        ...doc.data(),
      };

      saveMigratedChatData(doc.id, chatData, userData);
    });
  };

  const signInWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      // console.log("result", result);
      //get the photoUrl and other data and update it in the 'users' profile for this user

      if (appMode && appMode.googleLink === "true") {
        // console.log("google sign in result", result);
      } else {
        updateGoogleUserProfile(result.user);
        cookies.set("auth-token", result.user.refreshToken);
        setIsAuth(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const signInWithFacebook = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      updateGoogleUserProfile(result.user);
      cookies.set("auth-token", result.user.refreshToken);
      setIsAuth(true);
    } catch (err) {
      console.error(err);
    }
  };

  const signInWithApple = async () => {
    try {
      const result = await signInWithPopup(auth, appleProvider);
      updateGoogleUserProfile(result.user);
      cookies.set("auth-token", result.user.refreshToken);
      setIsAuth(true);
    } catch (err) {
      console.error(err);
    }
  };

  const signInAnon = async () => {
    // user input nickname
    // console.log("yes, we pass through here too");
    try {
      // NEVER stomp a live session. If any user (Google or anonymous) is
      // signed in by the time this fires — e.g. Firebase finished restoring
      // the persisted session, or a sign-in popup completed during the
      // grace delay below — minting a new anonymous uid here would silently
      // replace them. That was the "session drops to anonymous" bug.
      if (auth.currentUser) {
        setIsAuth(true);
        return;
      }
      // Before Firebase mints a new anonymous uid, check if we already
      // have a saved one from a prior visit. If the uids differ AFTER
      // sign-in, the device's primary auth storage was wiped (typically
      // iOS Safari ITP at 7 days, or an in-app browser launch) and we
      // can surface that so the UI/server can offer recovery later.
      // See ANONYMOUS_USER_PORTABILITY.md for the full design.
      let previouslyKnown = null;
      try { previouslyKnown = await readAnonCredentials(); } catch (_) {}

      const result = await signInAnonymously(auth);
      cookies.set("auth-token", result.user.refreshToken);

      // Stamp `anonymousSince` on this user's Firestore doc so downstream
      // code can identify anonymous guests across origin boundaries.
      // Firebase's own `auth.currentUser.isAnonymous` flag only survives
      // within a single origin — when the same user is bridged into a
      // sibling origin via `signInWithCustomToken`, `isAnonymous` flips
      // to `false` even though logically they're still a guest. Reading
      // this Firestore field gives every surface a consistent answer to
      // "is this user still a guest?" Cleared on successful Google link
      // in AnonLinkPrompt.js.
      try {
        await setDoc(
          doc(db, "users", result.user.uid),
          { anonymousSince: serverTimestamp() },
          { merge: true }
        );
      } catch (e) {
        console.warn("[signInAnon] anonymousSince write failed:", e?.message);
      }

      let recoveredIdentity = null;
      if (previouslyKnown?.uid && previouslyKnown.uid !== result.user.uid) {
        try {
          window.muuzboxPreviousAnonUid = previouslyKnown.uid;
          window.muuzboxPreviousAnonBackup = previouslyKnown;
        } catch (_) {}
        console.log(
          "[anonRecovery] device had a previous anonymous uid",
          previouslyKnown.uid,
          "→ new uid",
          result.user.uid,
          "(source:", previouslyKnown.source, ")"
        );
        // Full recovery: durably link the identities, move their points /
        // venue balances / request history onto the new uid (background),
        // and hand back the OLD name + avatar so the guest doesn't visibly
        // become someone else. Best-effort — never blocks sign-in.
        try {
          recoveredIdentity = await startAnonRecovery(previouslyKnown.uid, result.user.uid);
        } catch (e) {
          console.warn("[anonRecovery] start failed:", e?.message);
        }
      }

      // Mirror credentials to localStorage + cookie + a separate IndexedDB
      // store + Cache Storage so at least one surface survives storage
      // wipes from ITP / in-app browsers.
      saveAnonCredentials(result.user);
      // Recovered guests keep their previous identity; fresh guests get a
      // generated name + self-generated identicon (SVG data-URI — no dicebear
      // API call, no rate limits, deterministic from the uid).
      result.user.displayName =
        (recoveredIdentity && recoveredIdentity.displayName) ||
        result.user.uid.substring(0, 4) + " Guest";
      result.user.photoURL =
        (recoveredIdentity && recoveredIdentity.photoURL) ||
        identiconDataUri(result.user.uid.substring(0, 6));
      updateGoogleUserProfile(result.user);
      setIsAuth(true);
    } catch (err) {
      console.error(err);
    }
  };

  async function upgradeAnonymousToGoogle(credential) {
    try {
      const user = await linkWithCredential(auth.currentUser, credential);
      // Stamp the gained email onto the users doc — anon-born docs have
      // none, leaving the account unfindable by email until this write.
      try {
        const uid = user?.user?.uid || auth.currentUser?.uid;
        const linkedEmail = (user?.user?.email || auth.currentUser?.email || "").trim().toLowerCase();
        if (uid && linkedEmail) {
          await setDoc(doc(db, "users", uid), { email: linkedEmail }, { merge: true });
        }
      } catch (_) { /* non-fatal */ }
      return user;
    } catch (error) {
      console.error("Error upgrading anonymous account:", error);
    }
  }

  async function upgradeAnonymousUserToGoogle() {
    const user = auth.currentUser;

    if (user && user.isAnonymous) {
      // console.log("anon user", user);
      //logout of ananoymous and login with google, try retaining the anon data
      logout();
      try {
        // 1. Prepare Google provider
        // const provider = new GoogleAuthProvider();

        // 2. Sign in with Google popup (gets credential but doesn't sign in)
        const result = await signInWithPopup(auth, provider);
        try {
          // console.log("update firebase with this user if its new");
          // console.log("result", result);
          updateGoogleUserProfile(result.user);
          // console.log("reload the page");
          setTimeout(() => {
            window.location.reload();  
          }, 3000);
          
        } catch (err) {
          console.error(err);
        }
      } catch (error) {
        console.error("Error upgrading anonymous account:", error);
        if (error.code === "auth/credential-already-in-use") {
          // Optionally handle merging data here
          console.warn(
            "This Google account is already linked to another user."
          );
        }
      }
    } else {
      // console.log("User is not anonymous or not signed in.");
    }
  }

  // const signInWithFacebook = async () => {
  //   try {
  //     const result = await signInWithPopup(auth, facebookProvider);
  //     console.log("result", result);
  //     debugger;
  //     cookies.set("auth-token", result.user.refreshToken);
  //     setIsAuth(true);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // const signInWithApple = async () => {
  //   try {
  //     const result = await signInWithPopup(auth, appleProvider);
  //     console.log("result", result);
  //     debugger;
  //     cookies.set("auth-token", result.user.refreshToken);
  //     setIsAuth(true);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const currentUser = (e) => {
    onAuthStateChanged(auth, (user) => {
      e.preventDefault();
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        // const uid = user.uid;
        // console.log("currentUser", user);
        // ...
      } else {
        // User is signed out
        // ...
        // console.log("user is signed out");
      }
    });
  };

  const logout = async (e) => {
    await signOut(auth)
      .then(() => {
        // Sign-out successful.
        e.preventDefault();
        setIsAuth(false);
        // console.log("signed out");
        cookies.remove("auth-token");
        // Wipe the multi-storage anon backup too — the user is explicitly
        // signing out, so a previous-uid recovery prompt on next visit
        // would be wrong.
        try { clearAnonCredentials(); } catch (_) {}
      })
      .catch((error) => {
        // An error happened.
      });
  };

  const authListener = () => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        clearInputs();
        setUser(user);
        // Honour Firebase's own persisted session as the source of truth.
        // Previously isAuth only flipped true via a manual sign-in or the
        // anonymous fallback, so a RETURNING user whose `auth-token` cookie had
        // expired (mobile Safari ITP, or the tab/PWA was closed) was stranded on
        // the login screen and had to sign in with Google again — even though
        // Firebase still remembered them. Promote any remembered user (Google or
        // anonymous) straight into the app and refresh the cookie.
        try { cookies.set("auth-token", user.refreshToken); } catch (_) {}
        setIsAuth(true);
        // Refresh tokens rotate on each session — re-save to all backup
        // surfaces so we always have the latest token if we ever attempt
        // a recovery path. Skip for non-anonymous users — they have
        // proper sign-in credentials and don't need the backup.
        // Also wipe the backup if they've linked / upgraded to a real
        // account so we don't show "previous anon" prompts to a
        // signed-in person.
        if (user.isAnonymous) {
          try { saveAnonCredentials(user); } catch (_) {}
        } else {
          try { clearAnonCredentials(); } catch (_) {}
          // Belt-and-braces drain of pending Venue Access grants. Covers
          // users who signed in BEFORE the drain hook shipped OR who
          // took a code path that didn't hit updateGoogleUserProfile.
          // Anonymous users can't have grants queued (grants key on
          // email; anon users have none), so skip them.
          if (user.email) {
            applyPendingVenueAccess(user.uid, user.email).catch(() => {});
            applyPendingStaffInvite(user.uid, user.email).catch(() => {});
          }
        }
        // DO NOT call signInAnon() here. signInAnonymously() mints a
        // brand-new anonymous user and overwrites the auth-token cookie,
        // which would silently kick godbody (or any real user) off
        // immediately after a successful Google / email sign-in. The
        // anonymous-only flow already runs from the `else` branch below
        // when there genuinely is no user.
      } else {
        setUser("");
        // A null here is NOT proof there's no user: Firebase can emit a
        // transient null while the persisted session is still restoring
        // (slow IndexedDB read, Safari ITP, a token refresh hiccup) — and
        // signOut during the anon→Google upgrade also lands here mid-flow.
        // Minting a new anonymous user instantly would permanently replace
        // the real session. Grace-wait, then only go anonymous if there is
        // STILL no user.
        setTimeout(() => {
          if (!auth.currentUser) signInAnon();
        }, 2500);
      }
    });
  };
  useEffect(() => {
    // console.log("launched", launched);
    if (appMode && appMode.login === "true") {
      // console.log('lets get logged in')
      setIsAuth(false);
      // setRegisterForm(true)
      //do nothing just pause at the login form
    } else if (appMode && appMode.googleLink === "true") {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          // console.log('user', user)
          // console.log('appMode', appMode)
          // console.log(
          //   "switch up this anon user into a google account id",
          //   user
          // );
          //
          setAnonUser(user);
        } else {
          // console.log("no user persent. might need to now go do signInAnon");
        }
      });
    } else {
      // console.log('now call authListener')
      authListener();
    }
  }, [launched]);

  return (
    <>
      <div className="rounded-lg bg-black p-6">
        <h1 className="text-white py-2 text-center font-bold text-2xl">
          {/* {registerForm ? <span>Register</span> : <span>Login</span>} */}
        </h1>
        <div className="auth p-6 text-center">
          <img
            src="https://thisisobah.com/img/muuzbox-logo.png"
            className="loadlogo"
            alt="logo"
          />
          {appMode && appMode.googleLink === "true" ? (
            <>
              <button
                onClick={upgradeAnonymousUserToGoogle}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full inline-flex items-center"
              >
                <svg
                  fill="#000000"
                  width="30px"
                  height="20px"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5_logos</title>
                  <path d="M473.16,221.48l-2.26-9.59H262.46v88.22H387c-12.93,61.4-72.93,93.72-121.94,93.72-35.66,0-73.25-15-98.13-39.11a140.08,140.08,0,0,1-41.8-98.88c0-37.16,16.7-74.33,41-98.78s61-38.13,97.49-38.13c41.79,0,71.74,22.19,82.94,32.31l62.69-62.36C390.86,72.72,340.34,32,261.6,32h0c-60.75,0-119,23.27-161.58,65.71C58,139.5,36.25,199.93,36.25,256S56.83,369.48,97.55,411.6C141.06,456.52,202.68,480,266.13,480c57.73,0,112.45-22.62,151.45-63.66,38.34-40.4,58.17-96.3,58.17-154.9C475.75,236.77,473.27,222.12,473.16,221.48Z" />
                </svg>{" "}
                <span> Sign In With Google </span>
              </button>
            </>
          ) : (
            <div className="flex flex-col items-center gap-3">
              <button
                onClick={signInWithGoogle}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full inline-flex items-center"
              >
                <svg
                  fill="#000000"
                  width="30px"
                  height="20px"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5_logos</title>
                  <path d="M473.16,221.48l-2.26-9.59H262.46v88.22H387c-12.93,61.4-72.93,93.72-121.94,93.72-35.66,0-73.25-15-98.13-39.11a140.08,140.08,0,0,1-41.8-98.88c0-37.16,16.7-74.33,41-98.78s61-38.13,97.49-38.13c41.79,0,71.74,22.19,82.94,32.31l62.69-62.36C390.86,72.72,340.34,32,261.6,32h0c-60.75,0-119,23.27-161.58,65.71C58,139.5,36.25,199.93,36.25,256S56.83,369.48,97.55,411.6C141.06,456.52,202.68,480,266.13,480c57.73,0,112.45-22.62,151.45-63.66,38.34-40.4,58.17-96.3,58.17-154.9C475.75,236.77,473.27,222.12,473.16,221.48Z" />
                </svg>{" "}
                <span> Sign In With Google </span>
              </button>

              <button
                disabled
                title="Coming soon"
                className="bg-black text-white font-bold py-2 px-4 rounded-full inline-flex items-center border border-white/30 opacity-40 cursor-not-allowed"
              >
                <svg
                  fill="#ffffff"
                  width="30px"
                  height="20px"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                </svg>{" "}
                <span> Apple (coming soon) </span>
              </button>
            </div>
          )}
        </div>
        {/* <hr /> */}

        <div className="auth p-6 text-center">
          {/* <button
            onClick={signInAnon}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full inline-flex items-center"
          >

            <span> Anonymous Guest </span>
          </button> */}
        </div>

        {/*
          Emergency reset — always visible on the login screen so a wedged
          session can be recovered without DevTools or URL editing. Goes
          through the full nuke routine (Firebase auth, IndexedDB, Cache
          Storage, service workers, cookies, localStorage) then reloads.
        */}
        <div className="auth pb-6 text-center text-xs text-white/50">
          <button
            type="button"
            onClick={() => {
              const ok = window.confirm(
                "Reset the app?\n\nThis signs you out everywhere and clears all local data. You'll need to sign in again."
              );
              if (ok) resetAllState();
            }}
            className="underline hover:text-white/80"
          >
            Trouble signing in? Reset app
          </button>
        </div>

        {/* {registerForm ? (
          <div className="auth">
            <p> Register In With Email/Password To Continue </p>
            <input
              className="flex w-full border rounded-xl focus:outline-none focus:border-indigo-300 pl-4 h-10"
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <br />
            <input
              className="flex w-full border rounded-xl focus:outline-none focus:border-indigo-300 pl-4 h-10"
              type="password"
              id="authPassword"
              onChange={(e) => setPassword(e.target.value)}
            />
            <br />
            <button onClick={() => registerWithPassword()}>
              Register With Password
            </button>
            <br />
            <span
              className="text-white cursor-pointer"
              onClick={() => setRegisterForm(!registerForm)}
            >
              ready to Login
            </span>
          </div>
        ) : (
          <div className="auth">
            <p> Sign In With Email/Password To Continue </p>
            <div className="py-4">
              <input
                className="flex w-full border rounded-xl focus:outline-none focus:border-indigo-300 pl-4 h-10"
                type="email"
                id="email"
                value={email}
                placeholder="email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="py-4">
              <input
                className="flex w-full border rounded-xl focus:outline-none focus:border-indigo-300 pl-4 h-10"
                type="password"
                id="authPassword"
                placeholder="password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="py-4 text-center">
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full inline-flex items-center"
                onClick={() => signInWithPassword()}
              >
                <svg
                  width="30px"
                  height="20px"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M10 11H2.05C2.55 5.947 6.814 2 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-5.185 0-9.449-3.947-9.95-9H10v3l5-4-5-4v3z" />
                  </g>
                </svg>
                <span>Sign In With Password</span>
              </button>
            </div>
            <div>
              <span
                className="text-white cursor-pointer"
                onClick={() => setRegisterForm(!registerForm)}
              >
                Register
              </span>
            </div>
          </div>
        )} */}

        {/* <hr />
        <div className="auth">
          <p> Sign Out </p>
          <button onClick={(e) => logout(e)}> Sign Out </button>
        </div>
        <hr />
        <div className="auth">
          <p> Current User </p>
          <button onClick={(e) => currentUser(e)}> Current User </button>
        </div> */}

        {/* <div className="auth">
        <p> Sign In With Facebook To Continue </p>
        <button onClick={signInWithFacebook}> Sign In With Facebook </button>
      </div>

      <div className="auth">
        <p> Sign In With Apple To Continue </p>
        <button onClick={signInWithApple}> Sign In With Apple </button>
      </div> */}
      </div>
    </>
  );
};
